<template>
  <div class="home">
    <headerbox></headerbox>
    <div class="container">
      <div class="left_slids" @click="togglebox" :class="leftslids">
        <Icon :class="rotateIcon"  type="ios-arrow-forward"/>
      </div>
      <div class="cont_left" :class="leftClasses">
        <leftnav></leftnav>
      </div>
      <div class="cont_right" :class="rightClasses">
        <router-view/>
      </div>
      <div style="clear:both;"></div>
    </div>
    <div class="footerl">
      <!-- 主办单位：中国建筑工业出版社  -->
      经营许可证编号：
      <!-- <a target="_blank" href="http://www.beian.miit.gov.cn/publish/query/indexFirst.action" style="text-decoration: none;color:#515a6e">京ICP证150455号</a>  -->
      <a target="_blank" href="http://beian.miit.gov.cn" style="text-decoration: none;color:#515a6e">京ICP备13006569号-1</a> 
      京公网安备：11010802023620
      </div>
  </div>
</template>

<script>
import headerbox from "@/components/header/headerbox";
import leftnav from "@/components/leftNav/leftnav";
export default {
  name: "home",
  components: {
    headerbox,
    leftnav
  },
  data() {
    return {
      boxshow: true
    };
  },
  computed: {
    leftslids() {
      return ["cont_leftslids", this.boxshow ? "cont_leftslids_hide" : ""];
    },
    leftClasses() {
      return ["cont_leftwidth", this.boxshow ? "cont_leftwidth_hide" : ""];
    },
    rightClasses() {
      return ["cont_rightwidth", this.boxshow ? "cont_rightwidth_hide" : ""];
    },
    rotateIcon() {
      return ["menu-icon", this.boxshow ? "rotate-icon" : ""];
    }
  },
  methods: {
    togglebox: function() {
      this.boxshow = !this.boxshow;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{position: relative;}
.cont_left {
  background: #fff;
  overflow: hidden;
  padding-bottom: 9999px;
  margin-bottom: -9999px;
  height: 100%;
  float: left;
  transition: all 0.3s;
  position: absolute;
  width: 230px;
}
.cont_right {
  padding: 20px;
  min-height: 670px;
  float: right;
  background: #fff;
  z-index: 99;
}
.cont_leftwidth_hide {
  left: 0% !important;
  transition: all 0.3s;
}
.cont_leftwidth {
  left: -230px;
  transition: all 0.3s;
}

.cont_rightwidth {
  width: 99%;
  transition: all 0.3s;
}
.cont_rightwidth_hide {
  width: calc(100% - 250px);
  transition: all 0.3s;
}
.menu-icon {
  transition: all 0.3s;
}
.rotate-icon {
  transform: rotate(-180deg);
}
.left_slids {
  position: absolute;

  top: 270px;
  height: 100px;
  width: 30px;
  background: url(../../assets/images/shousuo2.png) no-repeat;
  line-height: 90px;
  color: #2d8cf0;
  z-index: 999;
}
.cont_leftslids {
  left: 0px;
  transition: all 0.3s;
}
.cont_leftslids_hide {
  left: 228px;
  transition: all 0.3s;
}
.home {
  min-height: 900px;
  background: #f0f0f0;
}
.container {
  width: 100%;
  margin: 20px auto;
  overflow: hidden;
}
.footerl {
  background: #fff;
  margin-top: 20px;
  width: 100%;
  height: 60px;
  text-align: center;
  line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/view/home/home.vue